import { Input } from 'reactstrap'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: auto 0;

  .checkbox {
    display: block;
    position: relative;
    padding-left: 30px;
    margin-bottom: 20px;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: ${(props) => (!props.disabled ? 'pointer' : 'unset')};
  }

  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    border-radius: 3px;

    background-color: ${(props) => (props.disabled ? '#ccc' : '#eee')};
  }
  .checkbox:hover input ~ .checkmark {
    background-color: ${(props) => !props.disabled && '#ccc'};
  }
  .checkbox input:checked ~ .checkmark {
    background-color: var(--blue);
  }
  .checkmark:after {
    content: '';
    position: absolute;
    display: none;
  }
  .checkbox input:checked ~ .checkmark:after {
    display: block;
  }
  .checkbox .checkmark:after {
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`

export const SelectBox = styled(Input)`
  position: absolute;
  opacity: 0;
  height: 0;
  width: 0;

  cursor: ${(props) => (!props.disabled ? 'pointer' : 'unset')};
`

export const Label = styled.label`
  color: ${(props) => props.isHighlight && 'var(--primary)'};
  font-size: ${(props) => props.isHighlight && '1.5rem'};
  font-weight: ${(props) => props.isHighlight && '600'};
  padding-top: 7px;
`
